// extracted by mini-css-extract-plugin
module.exports = {"highlight":"highlight_highlight__2QWbc","error":"highlight_error__cNCO2","errorIcon":"highlight_errorIcon__2NYd-"};